import Button from '@a24/ui/Button'

interface IProps {
  lineId?: string
  lineTitle: string
  linePrice: number
  seatRow?: string
  seatNumber?: string
  lineUnitPrice: number
  isServiceFee?: boolean
  onRemove?: (elementId: string) => void
}
const CartLine = ({
  lineId,
  linePrice,
  lineTitle,
  seatNumber,
  seatRow,
  lineUnitPrice,
  isServiceFee = false,
  onRemove
}: IProps) => {
  let lineExtendedTitle = lineTitle
  if (seatNumber && seatRow) {
    lineExtendedTitle += ` (${seatRow.toUpperCase()}${seatNumber})`
  }
  return (
    <div className='flex border border-heritage-off-white-80 rounded flex-row justify-between items-center py-2.5 px-3 bg-heritage-white-full text-heritage-soft-black-full body-sm '>
      <div className='flex gap-1'>
        <div>1 × {lineExtendedTitle}</div>
        {lineUnitPrice > 0 && (
          <>
            <div>·</div>
            <div className='text-heritage-off-white-40'>${lineUnitPrice}</div>
          </>
        )}
      </div>
      <div className='flex gap-3'>
        <div>${isServiceFee ? linePrice.toFixed(2) : linePrice}</div>
        {lineId && (
          <Button
            className='cursor-pointer'
            type='button'
            onClick={() => onRemove?.(lineId)}
          >
            X
          </Button>
        )}
      </div>
    </div>
  )
}

export default CartLine
